import * as z from "zod";

export const viewNavSource = z.enum(["nav", "tab_switch"]);

export type ViewNavSource = z.infer<typeof viewNavSource>;
